import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { useIntl } from "gatsby-plugin-intl"
import "./style.scss"
import { opcoesProdutos } from "../../FormularioContato/utils"

const BannerBuscaPorPlaca = () => {
  const intl = useIntl()

  return (
    <StaticQuery
      query={graphql`
        query QueryImagemBuscaPorPlaca {
          allFile(
            filter: { relativePath: { in: ["imagem-busca-por-placa.png"] } }
          ) {
            nodes {
              name
              extension
              childImageSharp {
                fluid(maxWidth: 519, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      `}
      render={data => {
        const imagemBuscaPorPlaca = data.allFile.nodes[0].childImageSharp.fluid

        return (
          <div className="banner-busca-por-placa">
            <div className="banner-busca-por-placa-content">
              <Img
                fluid={imagemBuscaPorPlaca}
                loading="eager"
                className="imgBuscaPorPlaca"
                alt="imagem da tela de busca por placa"
              />

              <div className="banner-busca-por-placa-container-texto">
                <h2>{intl.formatMessage({ id: "Busca por Placa" })}</h2>

                <h3>
                  {intl.formatMessage({
                    id: "A Busca por Placa chegou nos catálogos Ideia 2001.",
                  })}
                </h3>

                <p>
                  {intl.formatMessage({
                    id:
                      "Com ela, encontrar os produtos para o veículo do seu cliente ficou ainda mais fácil:",
                  })}
                </p>

                <p>
                  <b>1- </b>
                  {intl.formatMessage({
                    id: "Seu cliente informa a placa do veículo.",
                  })}
                  <br />
                  <b>2- </b>
                  {intl.formatMessage({
                    id:
                      "O catálogo identifica automaticamente o veículo e retorna todos os produtos compatíveis.",
                  })}
                </p>

                <p>
                  {intl.formatMessage({
                    id: "Economize tempo e simplifique suas vendas.",
                  })}
                </p>

                <p className="banner-busca-por-placa-texto-contrate">
                  {intl.formatMessage({
                    id: "Contrate já esse recurso para o seu catálogo!",
                  })}
                </p>

                <div className="banner-busca-por-placa-container-btn-tenho-interesse">
                  <Link
                    to={`/orcamento?interesse=${opcoesProdutos.buscaPorPlaca.param}`}
                    className="banner-busca-por-placa-btn-tenho-interesse"
                  >
                    {intl.formatMessage({ id: "Contate a Ideia 2001" })}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default BannerBuscaPorPlaca
